<ul class="sc-stepper__list">
  <li class="sc-stepper__list-item"
    *ngFor="let step of steps; let i = index;"
    [class.no-clickable]="disableClicks || step.id === currentStepId || disabled"
    [class.disabled]="step.disabled || disabled"
    [class.warning]="step.warning"
    [class.completed]="step.completed"
    [class.final]="step.final"
    [class.current]="step.id === currentStepId"
    (click)="handleClick(step)">
    <div class="sc-stepper__list-item-status">
      <sc-icon 
        *ngIf="step.warning || step.completed || (step.final && step.id === currentStepId); else number"
        class="sc-stepper__list-item-status-icon"
        [icon]="step.warning ? 'alert-elipse-copy':'done-rounded-flat'">
      </sc-icon>
      <ng-template #number>
        <span>{{ i + 1 }}</span>
      </ng-template>
    </div>
    <div class="sc-stepper__list-item-title">{{ step.label }}</div>
  </li>
</ul>
